<div class="error-page-wrap">
  <header class="site-header">
    <div class="container just-center aln-center">
      <a routerLink="/" class="site-logo">
        <!-- <img src='../../../../assets/images/logo.png' alt='site logo' /> -->
      </a>
    </div>
  </header>

  <!-- Error for forbidden case-->
  <div class="content-box container error-page" style="display: none;">
    <figure class="error-image">Error image</figure>
    <strong class="font-bold darker">Forbidden</strong>
    <p class="desc darker">You don't have permission to access / on this server</p>
    <button class="button" type="button" mat-flat-button color="primary">Go to Homepage</button>
  </div>

  <!-- Error for internal server case-->
  <div class="content-box container error-page" style="display: none;">
    <figure class="error-image error-500">Error image</figure>
    <strong class="font-bold darker">Internal Server Error</strong>
    <p class="desc darker">Please try again later or feel free to contact us if the problem persists</p>
    <button class="button" type="button" mat-flat-button color="primary">Go to Homepage</button>
  </div>

  <!-- Error for page not found case-->
  <div class="content-box container error-page">
    <figure class="error-image error-404">Error image</figure>
    <strong class="font-bold darker">Page Not Found</strong>
    <p class="desc darker">The page you are trying to access does not exist or has been moved.
      Try going back to our homepage.</p>
    <div class="signup-row"> <a routerLink="/" class="green-btn">Go to Home</a>
    </div>
  </div>

  <footer class="site-footer">
    <div class="container">
      <div class="newsletter-wrap">
      </div>
    </div>
    <div class="footer-links">
      <div class="container">
        <div class="copyright">{{footerText}}</div>
      </div>
    </div>
  </footer>
</div>